const DIMENSION_IDS = ['speciesGroupId', 'lengthGroupId', 'diameterGroupId', 'gradeId', 'endUseSortId']
const DIMENSION_NAMES = ['speciesGroupName', 'lengthGroupName', 'diameterGroupName', 'gradeName', 'endUseSortName']

export function sortKeyFor (line) {
  return DIMENSION_IDS.map(key => line[key] ?? '_').join('|')
}

export function sortLabelFor (line, fallback) {
  const names = DIMENSION_NAMES.map(key => line[key]).filter(name => !!name)
  return names.length > 0 ? names.join(' · ') : fallback
}
